/**
 * The studio's Upload page: the full drag-and-drop upload flow available to any role in the shell, for
 * solo creators who upload, remix and publish themselves. Snippet review lives on Analyse.
 */
import { Link, useRouteContext } from '@tanstack/react-router';
import { TopBar } from '@/components/shell';
import { UploadPanel } from '@/components/upload-panel';

export function UploadPage() {
  const { me } = useRouteContext({ from: '/_app' });
  return (
    <>
      <TopBar title="Upload" right={<Link to="/analyse" className="btn">Go to Analyse</Link>} />
      <section className="content col upload-page">
        <UploadPanel brandName={me.active?.brandName ?? null} batchTagging owner={me.active?.role === 'owner'} />
        <p className="sub creator-foot">Uploads analyse, tag themselves and land in the library automatically; fine-tune any step from the Analyse and Tagging pages.</p>
      </section>
    </>
  );
}
